import $ from "jquery";
import "slick-carousel-latest";
import "jquery-match-height";

const slickElementText = $('.js-whats-inside-text-slider');
const slickElementImage = $('.js-whats-inside-image-slider');
const whatsInsideMain = $('.js-whats-inside-main');
const whatsInsideTitle = $('.js-whats-inside-title');
const whatsInsideDescription = $('.js-whats-inside-description');
const flowSlider = $('.js-flow-slider');
const flowSliderPlane = $('.js-flow-plane-slider');

const initialDelay = 5000;

//Calculate height to use for the image margin-top in the what's inside section
function calculateHeight() {
    setTimeout(function() {
        slickElementImage.css('margin-top', '-'+ (whatsInsideDescription.outerHeight() - 5) +'px');    
    }, 500)
}

//Animation active fix for slick infinite loop
function slickFirstLastSlideItemAnimation(sliderElementClass, sliderItemActiveClass){
  $('.' + sliderElementClass).on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
      let direction;
  
      if (Math.abs(nextSlide - currentSlide) == 1) {
          direction = (nextSlide - currentSlide > 0) ? "right" : "left";
      }
      else {
          direction = (nextSlide - currentSlide > 0) ? "left" : "right";
      }
  
      if( direction == 'right' && nextSlide == 0 ){
          $('.' + sliderElementClass + ' .slick-slide').each(function(){
              if($(this).data('slick-index') == slick.slideCount){
                  $(this).addClass(sliderItemActiveClass);
              }
  
              if($(this).data('slick-index') == -1){
                  $(this).removeClass(sliderItemActiveClass);
              }
          });
      }
  
      if( direction == 'left' && parseFloat(slick.slideCount) - 1 == nextSlide ){
          $('.' + sliderElementClass + ' .slick-slide').each(function(){
              if($(this).data('slick-index') == slick.slideCount){
                  $(this).removeClass(sliderItemActiveClass);
              }
  
              if($(this).data('slick-index') == -1){
                  $(this).addClass(sliderItemActiveClass);
              }
          });
      }
  });
  
  $('.' + sliderElementClass).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      $('.' + sliderElementClass + ' .slick-slide').removeClass(sliderItemActiveClass);
  });
}

function sectionIndicatorId(){
  const sectionIndicatorArr = [];

  $('.page-template-discovery .section__indicator').each(function(){
      const distanceSection = $(this).offset().top - $('.header').outerHeight();
      const windowElem = $(window);
      const sectionIndicatorId = $(this).attr('id');

      if(windowElem.scrollTop() >= distanceSection ) {
          if (!sectionIndicatorArr.includes(sectionIndicatorId)) {
              sectionIndicatorArr.push(sectionIndicatorId);
          }
      }
  });

  return sectionIndicatorArr[sectionIndicatorArr.length - 1];
}

function activeNavMenuSwitcher(elem){
  const linkAttr = $(elem).attr('href');
  const parseLinkAttr = linkAttr.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');
  const element_id = $('.section--whats-inside > .section__indicator').attr('id');

  if(parseLinkAttr == sectionIndicatorId()){
      $(elem).addClass('active');
  }else{
      $(elem).removeClass('active');
  }

  //Trigger slick autoplay if it will reach the discovery phase
  if (sectionIndicatorId() === element_id) {
    setTimeout(function() {
        slickElementText.slick("slickPlay");
        slickElementImage.slick("slickPlay");
        whatsInsideMain.removeClass('is-default-active');
        whatsInsideMain.addClass('is-loaded');
    },initialDelay);
  }
}

function activeNavMenuOnLoadScroll(elem){
  const linkAttr = $(elem).attr('href');
  const parseLinkAttr = linkAttr.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');

  if(parseLinkAttr == window.location.hash){
      $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top
      }, 'slow');
  }
}

slickElementText.on('init', function(event, slick){
  whatsInsideTitle.matchHeight();  
});

slickElementImage.on('init', function(event, slick){
  whatsInsideDescription.matchHeight();
});

slickElementImage.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
  var i = (currentSlide ? currentSlide : 0) + 1;
  $('.js-index').text(i + '/' + slick.slideCount);
});

slickFirstLastSlideItemAnimation('js-whats-inside-text-slider', 'slick--active');
slickFirstLastSlideItemAnimation('js-flow-slider', 'slick--active');


$(window).on('resize', function() {
  calculateHeight();
});

$(window).on('load', function(){
  calculateHeight();

  $('.page-template-discovery .nav-link').each(function(){
      activeNavMenuOnLoadScroll(this);
  });
});

$(window).on('scroll', function(){
  $('.page-template-discovery .nav-link').each(function(){
      activeNavMenuSwitcher(this);
  });
});

slickElementText.slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    focusOnSelect: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000,
    swipe: false,
    infinite: true,
    fade: false,
    asNavFor: '.js-whats-inside-image-slider',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '55px',
                swipe: true,
            }
        },
    ] 
}).slick("slickPause");

slickElementImage.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    focusOnSelect: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000,
    swipe: false,
    infinite: true,
    fade: true,
    asNavFor: '.js-whats-inside-text-slider',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                swipe: true,
                arrows: true,
                appendArrows: $('.js-whats-inside-nav'),
                prevArrow: '<span class="prev d-inline-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none"><path fill="#222" d="M4.082.47.302 4.25l3.78 3.78.791-.81-2.408-2.407H13.75V3.688H2.465l2.408-2.409-.791-.808Z"/></svg></span>',
                nextArrow: '<span class="next d-inline-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none"><path fill="#222" d="m9.918 8.53 3.78-3.78L9.917.97l-.791.81 2.408 2.407H.25v1.125h11.285L9.127 7.721l.791.808Z"/></svg></span>',
            }
        },
    ] 
}).slick("slickPause");

whatsInsideTitle.on('mouseenter', function() {  
    $(this).trigger('click');
    whatsInsideDescription.css('opacity', '0');
    $(this).find('.whats-inside__description').css('opacity', '1');
    whatsInsideMain.removeClass('is-default-active');
    whatsInsideMain.addClass('is-loaded');
});

whatsInsideTitle.on('mouseleave', function() {  
    whatsInsideDescription.css('opacity', '');
});


//Flow section
flowSlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    var i = (currentSlide ? currentSlide : 0) + 1;
    $('.js-flow-index').text(i + '/' + slick.slideCount);
});

flowSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    focusOnSelect: true,
    centerMode: true,
    autoplay: false,
    centerPadding: '0',
    asNavFor: '.js-flow-plane-slider',
    swipe: false,
    infinite: true,
    fade: false,
    appendArrows: $('.js-flow-nav'),
    prevArrow: '<span class="prev d-inline-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none"><path fill="#222" d="M4.082.47.302 4.25l3.78 3.78.791-.81-2.408-2.407H13.75V3.688H2.465l2.408-2.409-.791-.808Z"/></svg></span>',
    nextArrow: '<span class="next d-inline-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none"><path fill="#222" d="m9.918 8.53 3.78-3.78L9.917.97l-.791.81 2.408 2.407H.25v1.125h11.285L9.127 7.721l.791.808Z"/></svg></span>',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                swipe: true,
                slidesToShow: 1,
            }
        },
    ] 
});

flowSliderPlane.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    fade: true,
    asNavFor: '.js-flow-slider'
});